import { Footer } from "@/components/ui/Footer";
import { Header } from "@/components/ui/Header";
import { Loading } from "@/components/ui/loading";
import { RecruitPositionsPage } from "@/pages/recruitPositions";
import { Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/recruit-positions/")({
	component: RouteComponent,
	pendingComponent: () => <Loading type="oval" />,
});

function RouteComponent() {
	return (
		<Stack gap={36}>
			<Header />
			<RecruitPositionsPage />
			<Footer />
		</Stack>
	);
}
